import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";
import axios from "axios";

function DrivingLicense() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    Driving_License_No: "",
    ifsc_code: "",
    Date_of_Issue: "",
    Validity_NT: "",
    Validity_T: "",
    DOB: "",
    Address: "",
    Pincode: "",
    District_Name: "",
    Statename: "",
    Document_Type: "",
    S_W_D: "",
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      Driving_License_No: "",
      ifsc_code: "",
      Date_of_Issue: "",
      Validity_NT: "",
      Validity_T: "",
      DOB: "",
      Address: "",
      Pincode: "",
      District_Name: "",
      Statename: "",
      Document_Type: "",
      S_W_D: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://0gpvsrcho2.execute-api.ap-south-1.amazonaws.com/default/DrivingLicenseService-API",
      headers: {
        "x-api-key": "Df5zsTe40V4tqQNevPgDU3vkoTjaWaus4RjIX6d1",
        authorizationToken: "vED0Abl2N513c5PI",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div className="container containerBoreder " id="pan">
          <h2 className="pageTitle">Driving License OCR</h2>
          <div className="row">
            <div className="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
          <br />
          <table className="table">
            <tbody>
              <tr>
                <th width="25%">Documemt Type: </th>
                <td> {cardData.Document_Type}</td>
              </tr>
              <tr>
                <th>License Number</th>
                <td>{cardData.Driving_License_No}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{cardData.Name}</td>
              </tr>
              <tr>
                <th>SO/WO/DO</th>
                <td>{cardData.S_W_D} </td>
              </tr>
          
              <tr>
                <th>Address</th>
                <td>{cardData.Address}</td>
              </tr>
              <tr>
                <th>Date of Issue</th>
                <td>{cardData.Date_of_Issue}</td>
              </tr>
              
              <tr>
                <th>Validity NT</th>
                <td>{cardData.Validity_NT}</td>
              </tr>
              <tr>
                <th>Validity T</th>
                <td>{cardData.Validity_T}</td>
              </tr>
              <tr>
                <th>Pincode</th>
                <td>{cardData.Pincode}</td>
              </tr>
              <tr>
                <th>District Name</th>
                <td>{cardData.District_Name}</td>
              </tr>
              <tr>
                <th>State Name</th>
                <td>{cardData.Statename}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{cardData.Address}</td>
              </tr>
              <tr>
  <th>Class_Of_Vehicle</th>
  <td>{cardData.Class_Of_Vehicle ? cardData.Class_Of_Vehicle.join(", ") : ""}</td>
</tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DrivingLicense;
